import { useTranslation } from "react-i18next";
import Select from "../../../../../components/Inputs/Select";

function EnabledDisabledSelect(props) {
	const { t } = useTranslation();
	return (
		<Select showSearch {...props}>
			<Select.Option value={true}>{t("enabled")}</Select.Option>
			<Select.Option value={false}>{t("disabled")}</Select.Option>
		</Select>
	);
}

export default EnabledDisabledSelect;
